import { defineStore } from 'pinia'

export const useWebsocketStore = defineStore('websocket', () => {
  const socketId = ref('')

  function setSocketId(id: string) {
    socketId.value = id
  }

  return {
    socketId,
    setSocketId
  }
})
